import React from 'react';

function Button({ url, buttonColor, buttonText }) {
  return (
    <a href={url} target={'_blank'} className={'btn-more'} rel="noopener noreferrer" style={{ backgroundColor: buttonColor }}>{buttonText}</a>
  );
}

export default Button;
